import React from 'react';
import { UnlabeledDataflowAlertCard } from '../components/UnlabeledDataflowAlertCard/UnlabeledDataflowAlertCard.esm.js';

class UnlabeledDataflowAlert {
  data;
  status;
  constructor(data) {
    this.data = data;
  }
  get url() {
    return "/cost-insights/labeling-jobs";
  }
  get title() {
    return "Add labels to workflows";
  }
  get subtitle() {
    return "Labels show in billing data, enabling cost insights for each workflow.";
  }
  get element() {
    return /* @__PURE__ */ React.createElement(UnlabeledDataflowAlertCard, { alert: this.data });
  }
}

export { UnlabeledDataflowAlert };
//# sourceMappingURL=UnlabeledDataflowAlert.esm.js.map
